import { useMemo } from 'react';
import trim from '../trim/index.js';
import IS_BROWSER from '../isBrowser/index.js';
import { l as languagesCodesListFull } from '../types-299e9037.js';

function usePageSlug() {
  var _a = IS_BROWSER && (window === null || window === void 0 ? void 0 : window.location) || {},
    pathname = _a.pathname,
    search = _a.search;
  var removeLanguageCodeFromRoute = useMemo(function () {
    return function (route) {
      var _a, _b;
      var locationDividedBySlash = route.split('/');
      var validLocation = route !== null && route !== void 0 ? route : '';
      if (['/', ''].includes(locationDividedBySlash === null || locationDividedBySlash === void 0 ? void 0 : locationDividedBySlash[0])) {
        locationDividedBySlash === null || locationDividedBySlash === void 0 ? void 0 : locationDividedBySlash.shift();
      }
      if (languagesCodesListFull.includes(locationDividedBySlash[0])) {
        locationDividedBySlash === null || locationDividedBySlash === void 0 ? void 0 : locationDividedBySlash.shift();
        validLocation = (_a = locationDividedBySlash === null || locationDividedBySlash === void 0 ? void 0 : locationDividedBySlash.join('/')) !== null && _a !== void 0 ? _a : '';
        return removeLanguageCodeFromRoute(validLocation);
      }
      validLocation = (_b = locationDividedBySlash === null || locationDividedBySlash === void 0 ? void 0 : locationDividedBySlash.join('/')) !== null && _b !== void 0 ? _b : '';
      return validLocation;
    };
  }, []);
  var getSlug = useMemo(function () {
    return function () {
      var validLocation = removeLanguageCodeFromRoute(pathname || '');
      return trim(validLocation, '/');
    };
  }, [pathname, removeLanguageCodeFromRoute]);
  var getLanguageParam = useMemo(function () {
    return function () {
      var _a;
      return (_a = languagesCodesListFull.find(function (x) {
        var _a;
        return x === ((_a = pathname === null || pathname === void 0 ? void 0 : pathname.split('/')) === null || _a === void 0 ? void 0 : _a[1]);
      })) !== null && _a !== void 0 ? _a : '';
    };
  }, [pathname]);
  var getSlugWithQueryParams = useMemo(function () {
    return function () {
      return "".concat(getSlug()).concat(search !== null && search !== void 0 ? search : '');
    };
  }, [getSlug, search]);
  var getFullPath = useMemo(function () {
    return function () {
      return "".concat(pathname).concat(search !== null && search !== void 0 ? search : '');
    };
  }, [pathname, search]);
  return {
    slug: getSlug(),
    slugWithQueryParams: getSlugWithQueryParams(),
    queryParams: search !== null && search !== void 0 ? search : '',
    languageParam: getLanguageParam(),
    fullPath: getFullPath()
  };
}

export { usePageSlug as default };
//# sourceMappingURL=index.js.map
